export default function snakeCase(title) {
  return (title === undefined) ? null : title.trim().toLowerCase().replace(/\s/g, "_");
}